$(document).on "turbolinks:load", ->

  #sets change password fields to hidden on load
  $("#create_new_password_field").hide()
  $("#confirm_password_field").hide()

  profileForm = document.querySelector("#edit_user")
  profileSaveButton = document.querySelector("#edit_page_save_button")
  profileFieldIds = [
    "first_name_field_value"
    "last_name_field_value"
    "email_field_value"
    "create-pass"
    "confirm-pass"
  ]
  profileFieldSelector = [
    "#first_name_field_value"
    "#last_name_field_value"
    "#email_field_value"
    "#create-pass"
    "#confirm-pass"
  ].join(", ")
  profileErrorSelector = [
    "#error-first_name"
    "#error-last_name"
    "#error-email"
    "#error-password"
    "#error-password_confirmation"
  ].join(", ")
  emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  passwordComplexityPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/

  # Enables and disables the save button
  updateProfileSaveButtonState = ->
    return unless profileSaveButton?

    hasError = $(profileErrorSelector).filter(".vb_error__container_visible").length > 0
    profileSaveButton.classList.toggle("disabled", hasError)
    if hasError
      profileSaveButton.setAttribute("disabled", "disabled")
    else
      profileSaveButton.removeAttribute("disabled")

  # Handles setting and displaying/hiding error messages
  handleDisplayError = (fieldId, message = "") ->
    fieldElement = document.querySelector("#" + fieldId)
    errorId = switch fieldId
      when "create-pass" then "error-password"
      when "confirm-pass" then "error-password_confirmation"
      else "error-#{fieldId.replace("_field_value", "")}"
    errorElement = document.querySelector("#" + errorId)
    return unless errorElement?

    hasError = $.trim(message).length > 0
    $(errorElement).find(".vb_error__text").html(message)
    errorElement.classList.toggle("vb_error__container_visible", hasError)

    if hasError
      fieldElement?.setAttribute("aria-invalid", "true")
      fieldElement?.setAttribute("aria-errormessage", errorElement.id)
    else
      fieldElement?.removeAttribute("aria-invalid")
      fieldElement?.removeAttribute("aria-errormessage")

    updateProfileSaveButtonState()

  # Validates the profile field and returns the error or a blank string
  validateFieldAndReturnError = (fieldId) ->
    fieldElement = document.querySelector("#" + fieldId)
    return "" unless fieldElement?
    return "" if fieldId in ["create-pass", "confirm-pass"] &&
                 !$("#flexCheckDefault").is(":checked")

    fieldValue = $.trim(fieldElement.value)
    if fieldValue == ""
      return fieldElement.dataset.profileRequiredError

    if fieldId == "email_field_value" && !emailPattern.test(fieldValue)
      return fieldElement.dataset.profileInvalidError

    if fieldId == "create-pass" && !passwordComplexityPattern.test(fieldElement.value)
      return fieldElement.dataset.profileComplexityError

    if fieldId == "confirm-pass" &&
       fieldElement.value != document.querySelector("#create-pass")?.value
      return fieldElement.dataset.profileConfirmationError

    return ""

  # Determines if all the fields are valid; submits the form if that's true
  validateAndSubmitProfile = ->
    valid = true
    profileFieldIds.forEach((fieldId) ->
      errorMessage = validateFieldAndReturnError(fieldId)
      handleDisplayError(fieldId, errorMessage)
      valid = ($.trim(errorMessage).length == 0) && valid
    )
    return unless valid

    $("#edit_user").attr("action", "validate_edit_user")
    Rails.fire(profileForm, "submit")

  window.clearProfileFieldErrors = ->
    $(profileErrorSelector).removeClass("vb_error__container_visible")
    $(profileErrorSelector).find(".vb_error__text").html("")
    $(profileFieldSelector).removeAttr("aria-invalid aria-errormessage")
    updateProfileSaveButtonState()

  window.showProfileFieldError = (errorId, fieldId, message) ->
    handleDisplayError(fieldId, message)

  window.updateProfileSaveButtonState = updateProfileSaveButtonState

  $(profileFieldSelector).off("blur.profileValidation").on("blur.profileValidation", ->
    handleDisplayError(this.id, validateFieldAndReturnError(this.id))
  )

  #clears error span message and password field when closing modal window
  $('#confirm-profile-changes').on('hidden.bs.modal', ->
    $("#user-password-error").html("")
    $("#current-password-field").val("")
  )
  #toggles view to show Edit Profile
  $("#edit_button").on("click", (e) ->
    toggleEditProfile(true)
  )

  $('#confirm-profile-changes').find('#submit_button').on("click", (e) ->
    $("#edit_user").attr('action', '/users')
    Rails.fire(profileForm, "submit")
  )

  $("#edit_page_save_button").on("click", (e) ->
    e.preventDefault()
    validateAndSubmitProfile()
  )
  #Toggles view to show My Profile and resets the Edit Profile fields
  $("#edit_page_cancel_button").on("click", (e) ->
    #Gets original resource values and stores them into variables
    prefix = document.getElementById("prefix_resource")
    first_name = document.getElementById("first_name_resource")
    last_name = document.getElementById("last_name_resource")
    suffix = document.getElementById("suffix_resource")
    email = document.getElementById("email_resource")

    e.preventDefault();
    toggleEditProfile(false);
    togglePasswordChange(false);

    #hides change password fields to bypass animation
    $("#create_new_password_field").hide();
    $("#confirm_password_field").hide();

    #uncheck checkbox
    $('#flexCheckDefault').prop('checked', false);

    #sets fields back to original resource value
    $("#first_name_field_value").val(first_name.value);
    $("#last_name_field_value").val(last_name.value);
    $("#email_field_value").val(email.value);

    #clear error messages
    window.clearProfileFieldErrors()

    #Checks if this account is a professor account by checking if prefix exists on the page
    is_professor = !!document.getElementById("prefix_resource");
    if is_professor
      #sets additional professor fields back to original resource value
      $("#prefix_field_value").val(prefix.value);
      $("#suffix_field_value").val(suffix.value);
  )

  #Check box to toggle the change password fields
  $("#flexCheckDefault").on("change", (e) ->
    if $(this).is(":checked")
      togglePasswordChange(true)
    else
      togglePasswordChange(false)
  )

  #functionality for password change checkbox
  togglePasswordChange = (check) ->
    if check
      #checkbox animation
      $("#create_new_password_field").fadeIn(300)
      $("#confirm_password_field").fadeIn(300)
      $("#password-fields").slideDown(200);
    else
      $("#password-fields").slideUp(200);
      $("#create_new_password_field").fadeOut(300)
      $("#confirm_password_field").fadeOut(300)

      #clears password text fields upon unchecking the checkbox
      $("#confirm-pass").val("");
      $("#create-pass").val("");
      handleDisplayError("create-pass", "")
      handleDisplayError("confirm-pass", "")
    return false

  toggleEditProfile = (edit) ->
    if edit
      #show edit view
      $('#edit_profile_page').show()
      $("#prefix_field").show()
      $("#first_name_field").show()
      $("#last_name_field").show()
      $("#suffix_field").show()
      $("#email_field").show()
      $("#user_persona").show()
      $("#edit_page_cancel_button").show()
      $("#edit_page_save_button").show()
      $("#edit_check_box").show()

      $("#prefix_resource").hide()
      $("#first_name_resource").hide()
      $("#last_name_resource").hide()
      $("#suffix_resource").hide()
      $("#email_resource").hide()
      $("#persona_resource").hide()
      $("#edit_button").hide()
      $("#my_profile_page").hide()

      #enables enter key to open for each text field if entries are valid
      openModal('#prefix_field_value')
      openModal('#first_name_field_value')
      openModal('#last_name_field_value')
      openModal('#suffix_field_value')
      openModal('#email_field_value')
      openModal('#create-pass')
      openModal('#confirm-pass')

    else
      #show my profile view
      $('#edit_profile_page').hide()
      $("#prefix_field").hide()
      $("#first_name_field").hide()
      $("#last_name_field").hide()
      $("#suffix_field").hide()
      $("#email_field").hide()
      $("#user_persona").hide()
      $("#edit_page_cancel_button").hide()
      $("#edit_page_save_button").hide()
      $("#edit_check_box").hide()

      $("#prefix_resource").show()
      $("#first_name_resource").show()
      $("#last_name_resource").show()
      $("#suffix_resource").show()
      $("#email_resource").show()
      $("#persona_resource").show()
      $("#edit_button").show()
      $("#my_profile_page").show()
    return false

  #Enables enter key to open modal (i.e. function the same as the save button)
  openModal = (field) ->
    $(field).keypress((event) ->
      if (event.keyCode == 13)
        event.preventDefault()
        validateAndSubmitProfile()
    );
    return false

  #Shows My Profile view on load
  toggleEditProfile(false)
  togglePasswordChange(false)
